<div [class]="getBadgeClasses()" tabindex="0">
    <ng-content></ng-content>
</div>
